import joi, { AnySchema } from 'joi';
import { SYSTEM_ISO_CODES } from '../system-languages';

export const $uuid = joi.string().uuid();
export const dateSchema = joi.string().isoDate();
export const languageSchema = joi.string().length(2).lowercase();
export const naturalNumberSchema = joi.number().integer().min(0);

export function localizedPropertySchema<T>(schema: AnySchema<T>) {
  return joi
    .object()
    .pattern(languageSchema, schema)
    .meta({
      schemaOverride: joi.object(
        Object.fromEntries(SYSTEM_ISO_CODES.map(language => [language, schema.optional()])),
      ),
    });
}
